<template>
  <transition name="show-mobile-menu" duration="600">
    <aside v-show="show_aside_bool"
           class="aside_dashboard">
      <div class="aside_dashboard__menu">
        <div class="aside_dashboard-logo">
          <router-link-to
              @click.native="hideMobileMenu"
            class="aside_dashboard-logo-item d-inline-block"
            :route_name="routes_names.dashboard">
            <img src="/images/logo.png" alt="logo">
            <span>{{ $app_name }}</span>
          </router-link-to>
          <div class="aside_dashboard-logo_hide" @click="hideMobileMenu">
            <svg viewBox="0 0 24 24" focusable="false" class="chakra-icon main-header_hide_icon" aria-hidden="true">
              <path fill="currentColor" d="M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"></path>
            </svg>
          </div>
        </div>
        <div v-if="!getUserRoleIsNewUser"
            class="aside_dashboard-links"
             ref="links">
          <router-link-to
            v-for="(route, key) in menu_list_top"
            @click.native="hideMobileMenu"
            :route_name="route.name"
            :key="`route_${key}`"
            class="aside_dashboard-links-item">
            <img :src="`/images/menu/${route.name.toLowerCase()}.svg`"
                 alt="aside images">
            <span>
              {{$t("routes." + route.name) || route.meta.title}}
            </span>
          </router-link-to>
        </div>
        <template v-if="settings_menu.length">
          <div
            class="aside_dashboard-links user-select-none"
            @click="toggleSettingsMenu()">
            <div
              class="aside_dashboard-links-item cursor_pointer justify-content-between">
              <gray-text>
                {{$t('menu.settings')}}
              </gray-text>
              <chevron-down-icon :rotate="active_settings_menu" size="14"/>
            </div>
          </div>
          <slide-up-down :active="active_settings_menu"
          :transition_duration_seconds="transition_duration_seconds"
          :forced_height="'600'">
            <div class="aside_dashboard-links">
              <div v-for="(route, key) in settings_menu">
                <router-link-to
                    @click.native="hideMobileMenu"
                    v-if="!route.meta.parent_of"
                    :route_name="route.name"
                    :key="`route_settings_${key}`"
                    class="aside_dashboard-links-item">
                  <img :src="`/images/menu/${route.name.toLowerCase()}.svg`"
                       alt="aside images">
                  <span>
                    {{$t("routes." + route.name) || route.meta.title}}
                  </span>
                </router-link-to>
                <div class="aside_dashboard-sub_menu_item"
                     v-else-if="route.meta.parent_of">
                  <div class="aside_dashboard-sub_menu_item-main"
                       @click="toggleHiddenRoutes(route)">
                    <div class="aside_dashboard-sub_menu_item-main_title">
                      <img class="aside_dashboard-sub_menu_item-main_img"
                           :src="`/images/menu/${route.name.toLowerCase()}.svg`"
                           alt="aside images">
                      <span>
                      {{$t("routes." + route.name)}}
                    </span>
                    </div>
                    <chevron-down-icon :rotate="!route.meta.hidden" size="14"/>
                  </div>
                    <slide-up-down :active="!route.meta.hidden"
                                   :transition_duration_seconds="transition_sub_item_duration_seconds"
                                   class="aside_dashboard-sub_menu_item-secondary">
                      <router-link-to
                          v-for="(route, key) in route.meta.parent_of"
                          @click.native="hideMobileMenu"
                          :route_name="route"
                          :key="`route_settings_${key}`"
                          class="aside_dashboard-links-item aside_dashboard-sub_menu_item-secondary-item">
                          <span>
                           - {{$t("routes." + route)}}
                          </span>
                        </router-link-to>
                    </slide-up-down>
                </div>
              </div>

            </div>
          </slide-up-down>
        </template>
      </div>
      <div class="mt-auto mb-20">
        <div class="aside_dashboard__footer">
          <span
            @click="logoutUser"
            class="aside_dashboard-links-item">
            <logout-icon
              class="mr-15"
              fill="#01ff85"
              :size="25"/>
              <span>
                Logout
              </span>
          </span>
        </div>
      </div>
    </aside>
  </transition>
</template>

<script>
import RouterLinkTo from "../small_components/RouterLinkTo";
import {mapActions, mapGetters} from 'vuex'
import {MAIN_MENU, ROUTES_NAMES, SETTING_MENU} from "../../router";
import LogoutIcon from "../icons/LogoutIcon";
import user_mixin from "../../mixins/user_mixin";
import SlideUpDown from "./SlideUpDown";
import ChevronDownIcon from "../icons/ChevronDownIcon";
import GrayText from "./GrayText";

export default {
  name: "AsideDashboard",
  mixins: [user_mixin],
  components: {
    GrayText,
    ChevronDownIcon,
    SlideUpDown,
    LogoutIcon,
    RouterLinkTo,
  },
  actions: {
    actionHideAside: () => this.hideMobileMenu(),
    actionShowAside: () => this.showMobileMenu(),
  },
  created() {
    this.show_aside
  },
  computed: {
    ...mapGetters([
      'getIsMobile',
      'getIsTablet',
      'getUserIsManager',
      'getUserRoleName',
      'getUserRoleIsAdmin',
      'getSelectedLanguage',
      'getAsideMenuMobile',
      'getLanguages',
      'getSelectedLanguage',
      'getUserRoleIsNewUser'
    ]),
    routes_names() {
      return ROUTES_NAMES
    },
    menu_list() {
      if (this.getUserRoleIsAdmin) {
        return MAIN_MENU.filter(menu => {
          let meta_manager = menu.meta?.manager || false
          if (meta_manager) {
            return (meta_manager && this.getUserIsManager);
          }
          return true
        });
      }
      return MAIN_MENU.filter(menu => {
        let meta_roles = menu.meta?.role || []
        let meta_manager = menu.meta?.manager || false
        if (meta_roles.length || meta_manager) {
          return meta_roles.includes(this.getUserRoleName) || (meta_manager && this.getUserIsManager);
        }
        return true
      });
    },
    getTranslatedRouteName(name) {
      return '';
    },
    menu_list_top() {
      return this.menu_list.filter(el => (el.meta.main_menu || false))
    },
    settings_menu() {
      if (!this.getUserRoleIsAdmin) return []
      return SETTING_MENU
    },
    show_aside() {
      if (
          !this.getIsTablet &&
          !this.getIsMobile
      ) {
        this.show_aside_bool = true
        return this.show_aside_bool
      }
      this.show_aside_bool = this.getAsideMenuMobile
      return this.show_aside_bool
    }
  },
  mounted() {
    const thisInstance = this;
    this.$nextTick(() => {
      this.$refs.links?.querySelector('.router-link-active')
        ?.scrollIntoView()
    });
    this.$root.$on('openAside', function(){
      thisInstance.showMobileMenu();
    })
  },
  data() {
    return {
      active_settings_menu: false,
      show_aside_bool: false,
      transition_duration_seconds: '0.3',
      transition_sub_item_duration_seconds: '0.3'
    }
  },
  methods: {
    ...mapActions([
      'actionShowAsideMenuMobile',
    ]),
    routeImage(route_name) {
      if (!route_name) {
        return `/images/menu/no-image.svg`
      }
      return `/images/menu/${route_name.toLowerCase()
        .replaceAll(' ', '-')}.svg`
    },
    hideMobileMenu() {
      if (
          this.getIsTablet ||
          this.getIsMobile
      )
      this.show_aside_bool = false
    },
    showMobileMenu() {
      this.show_aside_bool = true
    },
    toggleSettingsMenu() {
      this.transition_duration_seconds = '0.3'
      this.active_settings_menu = !this.active_settings_menu
    },
    toggleHiddenRoutes(route) {
      this.transition_duration_seconds = '0'
      this.active_settings_menu = !this.active_settings_menu;
      this.active_settings_menu = !this.active_settings_menu;
      route.meta.hidden = !route.meta.hidden
    }
  },
}
</script>
